import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {ReservationService} from "app/services";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {filterSchedules} from "./filter-schedules.slice";
import store from "../../../store";

interface SplitPassengerStateParams {
  id: string;
  body: any;
  onSuccess?: Function;
  onError?: Function;
}

export const splitPassengers =
    (params: SplitPassengerStateParams) => async (dispatch: Dispatch) => {
      const filters = store.getState().schedules.filterSchedules;
      try {
        dispatch(setLoading(true));
        const response = await ReservationService.splitPassengers(
            params.id,
            params.body
        );

        if (response.status >= 200 || response.status < 300) {
          dispatch(setSuccess(true));
          dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Passengers separated successfully!' : 'Pasagjerët u ndanë me sukses!'));
          if (params.onSuccess) params.onSuccess();
          dispatch(setError(""));
          // @ts-ignore
          dispatch(
              // @ts-ignore
              filterSchedules({
                ...filters,
                page: 0,
              })
          );
        }
        dispatch(setLoading(false));
      } catch (err) {
        dispatch(setLoading(false));
        dispatch(errorMsg(err.data.message));
        if (params.onError) params.onError();
        dispatch(setError(err.data.message));
      }
    };

interface SplitPassengerSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: SplitPassengerSlice = {
  error: "",
  success: false,
  loading: false,
};

const stateSlice = createSlice({
  name: "schedules/splitPassengers ",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;
